import React, { FunctionComponent, useRef, useState } from "react";
import { Grid, Typography } from "@material-ui/core";
import { useBillStyles } from "./useBillStyles";
import moment from "moment";
import { useStore } from "../../store";
type WithBillCounterDetails = {
  billDetails: any;
  creditCustomerAvailable: boolean;
  arabicDetails: any;
}
export const BillCounterDetails: FunctionComponent<WithBillCounterDetails> = ({
  billDetails,
  creditCustomerAvailable,
  arabicDetails
}) => {
  const classes = useBillStyles();
  const [user] = useStore("auth", "user");

  return (
    <div>
      <Grid container direction="row" >
        <Grid item xs={4} style={{ paddingTop: "3em" }}>
          <Typography align="left"
            className={classes.footerLeftDescription}
          >
            {
              arabicDetails.find((i: any) => i.code === "BILL_DISPLAY_CASHIER_SIGNATURE") !== undefined ?
                arabicDetails.find((i: any) => i.code === "BILL_DISPLAY_CASHIER_SIGNATURE").arabic_name : ""
            }
            <br />
                          Cashier Signature
                        </Typography>
        </Grid>
        {creditCustomerAvailable ?
          <Grid item xs={4} style={{ paddingTop: "3em" }}>
            <Typography align="center"
              className={classes.footerCenterDescription}

            >
              {
                arabicDetails.find((i: any) => i.code === "BILL_DISPLAY_CUSTOMER _SIGNATURE") !== undefined ?
                  arabicDetails.find((i: any) => i.code === "BILL_DISPLAY_CUSTOMER _SIGNATURE").arabic_name : ""
              }
              <br />
                            Customer Signature
                          </Typography>
          </Grid>
          : <Grid item xs={4} >{" "}</Grid>
        }
        <Grid item xs={4} style={{ paddingTop: "3em" }}>
          <Typography align="right"
            className={classes.footerCodeDescription}
          >{
              billDetails && billDetails.find((a: any) => a.store_code) !== undefined ?
                billDetails && billDetails.find((a: any) => a).store_code
                : ""}
                        /{" "}
            {
              billDetails && billDetails.find((a: any) => a.terminal_id) !== undefined ?
                billDetails && billDetails.find((a: any) => a).terminal_id
                : ""}
                          /{" "}
            {
              billDetails && billDetails.find((a: any) => a.user_code) !== undefined ?
                billDetails && billDetails.find((a: any) => a).user_code
                : ""}
          </Typography>
        </Grid>
      </Grid>
      <Grid container
        direction="row">
        <Grid item xs={6} style={{ paddingTop: "0.50em" }}>
          <Typography align="left"
            className={classes.footerLeftDescription}
          >
            {
              `Printed On: ${moment().format("DD-MMM-YYYY HH:mm:ss")}`
            }
          </Typography>
        </Grid>
        <Grid item xs={6} style={{ paddingTop: "0.50em" }}>
          <Typography align="right"
            className={classes.footerRighDescription}
          >
            {
              `Printed By : ${user.full_name}`
            }
          </Typography>
        </Grid>
      </Grid>
    </div>
  )
}